export const NumberedSvg = () => (
  <svg
    width="20"
    height="17"
    viewBox="0 0 20 17"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10654_68718)">
      <path
        d="M2.375 5C2.81258 5 3.16667 4.77785 3.16667 4.50332V0.496773C3.16667 0.295982 2.97419 0.114562 2.67805 0.0379405C2.38118 -0.0391772 2.04256 0.00350407 1.81524 0.145621L0.231918 1.13898C-0.0773059 1.33298 -0.0773059 1.64731 0.231918 1.84132C0.541142 2.03532 1.04216 2.03532 1.35138 1.84132L1.58334 1.69579V4.50332C1.58334 4.77785 1.93742 5 2.375 5Z"
        fill="currentColor"
      />
      <path
        d="M2.11111 12C0.946998 12 0 12.6684 0 13.4901C0 13.7646 0.314743 13.9868 0.703704 13.9868C1.09266 13.9868 1.40741 13.7646 1.40741 13.4901C1.40741 13.216 1.72285 12.9934 2.11111 12.9934C2.49937 12.9934 2.81481 13.216 2.81481 13.4901C2.81481 13.7641 2.49937 13.9868 2.11111 13.9868C1.72215 13.9868 1.40741 14.2089 1.40741 14.4834C1.40741 14.758 1.72215 14.9801 2.11111 14.9801C2.49937 14.9801 2.81481 15.2028 2.81481 15.4768C2.81481 15.7509 2.49937 16.0066 2.11111 16.0066C1.72285 16.0066 1.40741 15.7509 1.40741 15.4768C1.40741 15.2023 1.09266 14.9801 0.703704 14.9801C0.314743 14.9801 0 15.2023 0 15.4768C0 16.2985 0.946998 17 2.11111 17C3.27522 17 4.22222 16.2985 4.22222 15.4768C4.22222 15.0938 4.01074 14.7477 3.67315 14.4834C4.01074 14.2192 4.22222 13.8731 4.22222 13.4901C4.22222 12.6684 3.27522 12 2.11111 12V12Z"
        fill="currentColor"
      />
      <path
        d="M4.22222 7.5C4.22222 6.67287 3.27539 6 2.11148 6C0.947564 6 0.000730383 6.67287 0.000730383 7.5C0.000730383 7.77637 0.315419 8 0.704313 8C1.09321 8 1.40789 7.77637 1.40789 7.5C1.40789 7.22413 1.72329 7 2.11148 7C2.49967 7 2.81506 7.22413 2.81506 7.5C2.81506 7.60937 2.76698 7.7129 2.6749 7.7998L0.141588 10.2002C-0.205044 10.5279 0.123904 11 0.704313 11H3.51864C3.90753 11 4.22222 10.7764 4.22222 10.5C4.22222 10.2236 3.90753 10 3.51864 10H2.11148L3.80031 8.3999C4.07653 8.13867 4.22222 7.82763 4.22222 7.5Z"
        fill="currentColor"
      />
      <path
        d="M18.3333 1H6.66667C5.74617 1 5 1.67155 5 2.5C5 3.32835 5.74617 4 6.66667 4H18.3333C19.2538 4 20 3.32835 20 2.5C20 1.67155 19.2538 1 18.3333 1Z"
        fill="currentColor"
      />
      <path
        d="M18.3333 7H6.66667C5.74617 7 5 7.67155 5 8.5C5 9.32835 5.74617 10 6.66667 10H18.3333C19.2538 10 20 9.32835 20 8.5C20 7.67155 19.2538 7 18.3333 7Z"
        fill="currentColor"
      />
      <path
        d="M18.3333 13H6.66667C5.74617 13 5 13.6715 5 14.5C5 15.3284 5.74617 16 6.66667 16H18.3333C19.2538 16 20 15.3284 20 14.5C20 13.6715 19.2538 13 18.3333 13Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
